import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BsPencil, BsCheck, BsX } from "react-icons/bs";
import { Row, Col, Form } from "react-bootstrap";
const ContactView = ({ data, setSelectedContactDetails }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedContactData, setEditedContactData] = useState(data);
    const [setupIdError, setSetupIdError] = useState('');
    const [isSetupIdEditing, setIsSetupIdEditing] = useState(false);
    const [contactTypes, setContactTypes] = useState([]);
    const [editField, setEditField] = useState(null);

    const handleChange = async (e) => {
        const { name, value } = e.target;

        setEditedContactData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        // When contact_type is selected, fetch relevant contact types
        if (name === 'contact_type') {
            fetchContactTypes(value); // Pass the selected type
            // Clear previously selected contact type when changing type
            setEditedContactData((prevState) => ({
                ...prevState,
                type_id: ''
            }));
        }
    };


    const handleSave = async () => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.put(`${backendUrl}/api/contact/${data.id}`, editedContactData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            setSelectedContactDetails((prevDetails) => ({
                ...prevDetails,
                ...editedContactData, // Update only the changed fields
            }));
            setEditField(null);
        } catch (error) {

            console.error('Error saving contact details:', error);

        }
    };

    const fetchContactTypes = async (type) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const API_URL = `${backendUrl}/api/contact-type?category=${type}`; // Pass type as query param
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(API_URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });
            setContactTypes(response.data.data); // Assuming API returns filtered data
        } catch (error) {
            console.error('Error fetching contactTypes:', error);
        }
    };
    // Fetch contact types on load based on contact_type
    useEffect(() => {
        if (data.contact_type) {
            fetchContactTypes(data.contact_type);
        }
    }, [data.contact_type]);

    // Update form data when new data comes
    useEffect(() => {
        setEditedContactData(data);
    }, [data]);

    const getTypeName = (id) => {
        if (!id) return "--";
        if (contactTypes.length === 0) return "Loading...";
        const type = contactTypes.find((ven) => Number(ven.id) === Number(id));
        return type ? type.name : "--";
    };


    const fields = [
        { name: 'name', label: 'Name', type: 'text' },
        { name: 'email', label: 'Email', type: 'text' },
        { name: 'phone', label: 'Phone Number', type: 'text' },
        { name: 'position', label: 'Position', type: 'text' },
        {
            name: 'contact_type', label: 'Type', type: 'select', options: [
                { label: 'Internal', value: 'internal' },
                { label: 'External', value: 'external' },
            ]
        },
        {
            name: 'type_id', label: 'Contact Type', type: 'select', options: contactTypes.map(type => ({
                label: type.name,
                value: type.id
            })), format: getTypeName
        },
    ];



    const visibleFields = fields.filter((field) => {
        if (field.name === 'type_id') {
            return editedContactData.contact_type; // Only show if type is selected
        }
        return true;
    });

    const rows = [];
    for (let i = 0; i < visibleFields.length; i += 3) {
        rows.push(visibleFields.slice(i, i + 3));
    }


    return (
        <div className="p-3 font-size-12">
            <Row>
                {visibleFields.map((field, index) => (
                    <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
                        <strong className="view-label">
                            {field.label}:
                        </strong>
                        <div className="editable-container d-flex align-items-center">
                            {editField === field.name ? (
                                <div className="d-flex align-items-center">
                                    {field.type === "select" ? (
                                        <Form.Select
                                            name={field.name}
                                            value={editedContactData[field.name] || ""}
                                            onChange={handleChange}
                                            autoFocus
                                            className="form-control form-feild"
                                        >
                                            <option value="">Select</option>
                                            {field.options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            name={field.name}
                                            value={editedContactData[field.name] || ""}
                                            onChange={handleChange}
                                            autoFocus
                                            className="form-control form-feild"
                                        />
                                    )}
                                    <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
                                    <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
                                </div>
                            ) : (
                                <div className="hover1" onClick={() => setEditField(field.name)}>
                                    <span className="hover-field1">
                                        {
                                            field.name === "type_id" ? getTypeName(editedContactData[field.name]) :
                                                editedContactData[field.name] || "--"}
                                    </span>
                                    <BsPencil className="text-primary pencil-icon1" />
                                </div>
                            )}
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
    // return (
    //     <div className="page-details">
    //         <h4>Contact Info</h4>
    //         <br />
    //         <div className="card">
    //             <div className="card-body">
    //                 <form>
    //                     {/* Dynamically render rows */}
    //                     {rows.map((row, rowIndex) => (
    //                         <div className="row" key={`row-${rowIndex}`}>
    //                             {row.map((field) => {
    //                                 const fieldValue = editedContactData[field.name];
    //                                 // Check conditions for rendering the field
    //                                 if (
    //                                     (fieldValue || isEditMode)

    //                                 ) {
    //                                     return (
    //                                         <div className="col-md-4 mb-3" key={field.name}>
    //                                             <label className="col-form-label" style={{ fontSize: '13px' }}>
    //                                                 {field.label}
    //                                             </label>
    //                                             {renderField(field)}

    //                                         </div>
    //                                     );
    //                                 }
    //                                 return null; // Explicitly return null for fields that shouldn't render
    //                             })}
    //                         </div>
    //                     ))}

    //                     {/* Save or Edit Buttons */}
    //                     <div className="d-flex justify-content-end">
    //                         {isEditMode ? (
    //                             <button type="button" className="btn btn-secondary" onClick={handleSave}>
    //                                 Save
    //                             </button>
    //                         ) : (
    //                             <button type="button" className="btn btn-secondary" onClick={() => setIsEditMode(true)}>
    //                                 Edit
    //                             </button>
    //                         )}
    //                     </div>
    //                 </form>
    //             </div>
    //         </div>
    //     </div>
    // );
};

export default ContactView;
